import * as React from 'react';
import * as moment from 'moment';

import { GridDayProps } from '../../components/grid/day';

import GridEventView from 'grid-event.view';
import { MonthSelectionDropdownProps } from '../../components/month-selection/dropdown';
import { CalendarViewMode } from '../../classes/calendar';
import { scrollToMonth } from '../../helpers/scroll-to-month';

const momentFormat = 'YYYY-MM';

const MonthSelectionDropdownView: React.StatelessComponent<MonthSelectionDropdownProps> = props => {
    function goToMonthChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const mmt = moment(evt.currentTarget.value, momentFormat);

        props.goToMonth(mmt);

        var focusDestinationMonth = setInterval(() => {
            if (scrollToMonth(mmt)) {
                clearInterval(focusDestinationMonth);
            }
        }, 500);
    }

    return (
        <div className="stack-xs">
            <label htmlFor="MonthDropdown">{props.text.monthDropdownDescriptionText}</label>
            <select value={props.currentMonth.format(momentFormat)} onChange={goToMonthChange} id="MonthDropdown">
                {
                    props.validMonths.map(month => <option key={month.format(momentFormat)} value={month.format(momentFormat)}>{month.format("MMMM YYYY")}</option>)
                }
            </select>
        </div>
    );
}

export default MonthSelectionDropdownView;